export const DAPP_QUERIES = ['Validators']
